/** Détecte si une unité correspond à un montant en euros (et non un temps en heures). */
export const isMonetaryUnit = (unit) => {
  if (!unit) return false;
  return unit.includes('€');
};

/**
 * Arrondit au multiple de 5 supérieur (prix finissant par 0 ou 5).
 * Ex. 11 → 15, 10 → 10, 15.1 → 20.
 */
export const roundPrice = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return 0;
  return Math.ceil(num / 5) * 5;
};

/**
 * Applique une augmentation sur un montant, puis arrondit au 0/5 supérieur.
 * @param {number} value
 * @param {{ mode: 'percent' | 'fixed', amount: number }} adjustment
 */
export const applyPriceAdjustment = (value, { mode, amount }) => {
  const base = Number(value) || 0;
  const delta = Number(amount) || 0;
  if (delta <= 0) return base;

  const next = mode === 'percent'
    ? base * (1 + delta / 100)
    : base + delta;

  return roundPrice(Math.max(0, next));
};

export const formatAdminPrice = (value, unit = '€') => {
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  const formatted = num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  if (unit === '€' || unit === '€/h' || unit === '€/an' || unit === '€/mot' || unit === '€/compte/an') {
    return `${formatted} ${unit}`;
  }
  return `${formatted} ${unit}`;
};

/** Affichage compact type « 1 234 € » pour les cellules admin. */
export const formatEurCell = (value) => {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (Number.isNaN(num)) return '—';
  return `${num.toLocaleString('fr-FR')} €`;
};

export const PERCENT_PRESETS = [3, 5, 10];
